import google_maps_logo from "../images/maps_logo.png";
const AshramCard = ({ branch }) => {
  return (
    <div className="ashram-card">
      <div className="ashram-place">Place: {branch.place}</div>
      <div className="ashram-address">Address: {branch.address}</div>
      <div>
        
        <div className="ashram-maplink">
         Location: <a href={branch.map_link} target="_blank" rel="noreferrer">
            View on map
          </a>
          <img
            src={google_maps_logo}
            alt="Google map icon"
            width="30px"
            height="30px"
          />
        </div>
      </div>
    </div>
  );
};
export default AshramCard;
